import React from "react";
import { useUser } from "@clerk/clerk-react";
import useApi from "../../../shared/hooks/useApi";

import LoadingSpinner from "../../../shared/components/UIElements/LoadingSpinner";
import { CreditCardIcon } from "@heroicons/react/20/solid";
import { PencilSquareIcon } from "@heroicons/react/16/solid";
import { Link } from "react-router-dom";

function renderSummary(pm) {
	if (!pm || !pm.type) return "Geen betaalmethode gevonden";
	if (pm.type === "sepa_debit") {
		return `SEPA incasso • IBAN •••• ${pm.ibanLast4 || ""}`;
	}
	if (pm.type === "card") {
		const brand = pm.brand ? pm.brand.toUpperCase() : "Card";
		const exp =
			pm.expMonth && pm.expYear ? ` • ${pm.expMonth}/${pm.expYear}` : "";
		return `${brand} •••• ${pm.last4 || ""}${exp}`;
	}
	return pm.type;
}

export default function CurrentPaymentMethod() {
	const { user } = useUser();
	const { data, loading } = useApi(
		user?.id ? `/api/billing/settings/payment-method/${user.id}` : null,
	);
	const { data: changeMethodUrl, loading: changeLoading } = useApi(
		user?.id ? `/api/billing/change-payment-method/${user.id}` : null,
	);

	return (
		<div className="">
			<div className="flex items-center gap-2">
				<CreditCardIcon className="size-5 text-brand-intense" />
				<h2 className="text-lg font-semibold">Factuurgegevens</h2>
			</div>

			<div className="mt-4 flex flex-col space-y-3">
				<div>
					<p className="text-xs text-slate-600">Naam</p>
					<p className="text-sm font-medium text-slate-900">
						{loading ? <LoadingSpinner /> : data?.customer?.name || "-"}
					</p>
				</div>

				<div>
					<p className="text-xs text-slate-600">E-mail</p>
					<p className="text-sm font-medium text-slate-900">
						{loading ? <LoadingSpinner /> : data?.customer?.email || "-"}
					</p>
				</div>

				<div className="">
					<p className="text-xs text-slate-600">Adres</p>
					<p className="text-sm font-medium text-slate-900">
						{loading
							? <LoadingSpinner />
							: (
								[
									data?.customer?.address?.line1,
									data?.customer?.address?.line2,
									data?.customer?.address?.postalCode,
									data?.customer?.address?.city,
									data?.customer?.address?.country,
								]
									.filter(Boolean)
									.join(", ") || "-"
							)}
					</p>
				</div>
			</div>

			<div className="mt-4 bg-slate-50 rounded-lg p-2 w-fit border border-slate-200">
				<p className="text-xs text-slate-600">Betaalmethode</p>
				<div className="flex items-center gap-2">
					<p className="text-sm font-medium text-slate-900">
						{loading ? <LoadingSpinner /> : renderSummary(data?.paymentMethod)}
					</p>
					<Link to={changeMethodUrl} target="_blank" title="Wijzig betaalmethode">
						<PencilSquareIcon className="size-4 text-brand-intense" />
					</Link>
				</div>
			</div>
		</div>
	);
}
